import { LocalStorage } from '../utils/storage-helpers';
import { AppConfigMapper } from './app-config-mapper';

export const appConfig = AppConfigMapper.toAppConfig(process.env);
export const getCompanyId = (): string =>
  LocalStorage.getValue(appConfig.appAccessControlCompaniesLocalKey) ?? '';
